import { useCallback, useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import type { OrchestrationNameFilterModel } from './types';
import { dashboardFilterAtom } from '../../filterAtom';

export const useOrchestrationFilter = (
  model: OrchestrationNameFilterModel | null
) => {
  const setDashboardFilter = useSetAtom(dashboardFilterAtom);
  const previousModelReference = useRef<OrchestrationNameFilterModel | null>(
    null
  );

  const updateAtom = useCallback(
    (newModel: OrchestrationNameFilterModel | null) =>
      setDashboardFilter((previousFilter) => ({
        ...previousFilter,
        workflowNames:
          newModel?.workflowNames && newModel.workflowNames.length > 0
            ? newModel.workflowNames
            : null,
      })),
    [setDashboardFilter]
  );

  useEffect(() => {
    const currentWorkflowNames = model?.workflowNames || [];
    const previousWorkflowNames =
      previousModelReference.current?.workflowNames || [];

    const hasChanged =
      currentWorkflowNames.length !== previousWorkflowNames.length ||
      currentWorkflowNames.some(
        (name: string, index: number) => name !== previousWorkflowNames[index]
      );

    if (hasChanged) {
      updateAtom(model);
      previousModelReference.current = model;
    }
  }, [model, updateAtom]);
};
